import { ListConfigType } from '../../SideNav/SideNavContainer';

export default function addClickHandler(
	config: ListConfigType,
	closeMobileMenu: () => void
) {
	return config.map( ( item ) => {
		return {
			...item,
			onClick: () => {
				if ( 'onClick' in item ) {
					item.onClick?.();
				}
				closeMobileMenu();
			},
		};
	} );
}
